function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

// References:
// https://govuk-elements.herokuapp.com/buttons/
//
// https://github.com/alphagov/govuk_frontend_toolkit/blob/master/stylesheets/design-patterns/_buttons.scss
// https://github.com/alphagov/govuk-frontend/blob/master/src/components/button/_button.scss
// https://github.com/alphagov/govuk_elements/blob/master/packages/govuk-elements-sass/public/sass/elements/_buttons.scss
import styled from 'react-emotion';
import PropTypes from 'prop-types';
import React from 'react';
import { withWhiteSpace } from '@govuk-react/hoc';
import { NTA_LIGHT, SPACING } from '@govuk-react/constants';
import { BUTTON_COLOUR, BUTTON_COLOUR_DARKEN_15, WHITE, YELLOW } from 'govuk-colours'; // TODO should be using constants for some of the below values

var StyledButton = styled('button')({
  backgroundColor: BUTTON_COLOUR,
  border: 'none',
  boxShadow: "0 2px 0 " + BUTTON_COLOUR_DARKEN_15,
  color: WHITE,
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  fontFamily: NTA_LIGHT,
  fontWeight: 400,
  fontSize: '1em',
  lineHeight: '1.25',
  outlineOffset: '-1px',
  outline: '1px solid transparent',
  padding: '.526315em .789473em .263157em',
  textDecoration: 'none',
  WebkitAppearance: 'none',
  WebkitFontSmoothing: 'antialiased',
  ':focus': {
    outline: "3px solid " + YELLOW
  },
  // TODO: avoid cascade
  ' svg': {
    maxWidth: '15px',
    marginLeft: SPACING.SCALE_4
  }
}, function (_ref) {
  var start = _ref.start,
      icon = _ref.icon,
      disabled = _ref.disabled;
  return {
    opacity: disabled ? '.5' : '1',
    pointerEvents: disabled ? 'none' : 'auto',
    fontWeight: start ? '700' : undefined,
    fontSize: start ? '24px' : undefined,
    lineHeight: start ? '1.25' : undefined,
    padding: start ? '.36842em .84211em .21053em' : undefined,
    paddingRight: icon ? '.54211em' : '.84211em'
  };
}); // TODO: start and iconUrl props

var Button = function Button(_ref2) {
  var children = _ref2.children,
      icon = _ref2.icon,
      className = _ref2.className,
      props = _objectWithoutProperties(_ref2, ["children", "icon", "className"]);

  return React.createElement(StyledButton, _extends({
    icon: icon,
    className: className
  }, props), children, icon);
};

Button.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.string,
  children: PropTypes.node,
  icon: PropTypes.node
} : {};
Button.defaultProps = {
  className: undefined,
  children: 'Button',
  icon: undefined
};
export default withWhiteSpace({
  marginBottom: 4
})(Button);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/button/es/index.js
// module id = 76
// module chunks = 0